<div class="p-2 border rounded border-solid border-gray-300 dark:border-gray-500 uppercase text-lg text-gray-500">

  <div class="flex flex-col text-center">
    <h3 class="text-gray-500 dark:text-gray-50 font-bold text-base">Boleto - lectura  código</h3>
    <hr class="mt-2 mb-2">

    <div class="grid grid-cols-2 gap-4">

      <div class="col-start-1 w-96">

        <app-teclado-numerico (change)="onChangeTN($event)"  (valueResponse)="recibiRespuesta($event)" [multipleInputs]="false"
          (confirmValue)="validateScanCode($event)" placeholder="codigo QR"></app-teclado-numerico>

        <div class="mt-2">
          <button (click)="cancelAction()"
            class="bg-blue-600 p-3 w-full text-white font-bold uppercase border border-transparent hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Cancelar</button>
        </div>

      </div>

      <div *ngIf="formulario">
          <table style="border-radius:6mm;margin-bottom:3mm;" [style.background]="color"class="table w-full">
              <tr>

                  <td colspan="4">
                  <center><h2 style="font-size: 18pt;font-weight: bold;">Valido para {{formulario?.transportista}}</h2></center>
                  <div style="background:white; padding:2px; color:red; font-size: 18pt;font-weight: bold;">No. {{formulario?.no_boleto}}</div></td>
              </tr>
              <tr>
                  <td class="td-bg-white" [style.color]="color">TARIFA</td>
                  <td class="td-bg-white" [style.color]="color " colspan=2>VEHICULO</td>
                  <td class="td-bg-white" [style.color]="color ">CUOTA</td>
              </tr>
              <tr>
                  <td class="td-bg-white" [style.color]="color" style="font-size: 22pt;font-weight: bold;" rowspan="2">{{formulario?.tipo}}</td>
                  <td class="td-bg-white" [style.color]="color" style="font-weight: bold; font-size: 15pt;" rowspan="2" colspan=2>{{formulario?.clasificacion}}</td>
                  <td class="td-bg-white" [style.color]="color">DERECHO DE PEAJE</td>
              </tr>
              <tr>
                  <!-- <td class="td-bg-white" [style.color]="color" style="font-size: 18pt;font-weight: bold;">${{formulario?.monto}}</td> -->
              </tr>

          </table>
          <div class="space-y-12">
            <div class="border border-dashed  pb-12">
              <h2 class="text-base font-semibold leading-7  dark:text-gray-100">Detalle del boleto</h2>












              <!-- <p class="mt-1 text-sm leading-6  dark:text-gray-100">empresa: {{formulario?.transportista}}</p>
              <p class="mt-1 text-sm leading-6  dark:text-gray-100">tipo:  </p>
              <p class="mt-1 text-sm leading-6  dark:text-gray-100">importe: ${{formulario?.monto}} </p>
              <p class="mt-1 text-sm leading-6  dark:text-gray-100">fecha emisión: {{formulario?.fecha_emision | date: 'dd/MM/yyyy'}} </p> -->
                <div class="sm:col-span-4 border border-dashed bg-green-500">
                  <label for="username" class="block text-sm font-medium leading-6  dark:text-gray-100 ">BOLETO VALIDO!</label>
                  <p class="mt-1 text-sm leading-6  dark:text-gray-100">FAVOR DE CONFIRMAR EL CRUCE </p>
                </div>
                <!-- <div class="sm:col-span-4 border border-dashed bg-green-500">
                  <label for="username" class="block text-sm font-medium leading-6  dark:text-gray-100 ">BOLETO INVALIDO!</label>
                  <p class="mt-1 text-sm leading-6  dark:text-gray-100">FAVOR DE CONFIRMAR EL CRUCE </p>
                </div> -->
                <div class="mt-6 flex items-center justify-end gap-x-6">
                  <button class="btn bg-gray-50 dark:bg-transparent rounded py-2 px-2 w-full  dark:text-gray-100  text-normal font-semibold border-2 border-gray-300 dark:border-gray-400 drop-shadow-lg hover:border-blue-600 uppercase" (click)="saveScanCode()">Confirmar</button>

                </div>
            </div>

          </div>
      </div>
